export const errors = {
  documentTitle: "Errors",
  title: "Errors",
  refresh: "Refresh",
  kind_label: "Kind",
  source_filter_label: "Filter by source",
  empty: "No reported errors recorded yet.",
  columns: {
    id: "ID",
    kind: "Kind",
    source: "Source",
    message: "Message",
    timestamp: "Timestamp",
    details: "Details",
  },
  kindOptions: [
    { title: "csp-violation", value: "csp-violation" },
    { title: "client", value: "client" },
    { title: "server", value: "server" },
    { title: "test", value: "test" },
  ],
};
